import { Injectable } from '@angular/core';
import {
  CanActivate,
  Router,
} from '@angular/router';
import { AuthUserService } from '../services/auth-user.service';
import { APP_ROUTES } from 'app/common/constants';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private authUserService: AuthUserService,
              private router: Router) { }

  canActivate(): boolean {
    if (this.authUserService.isAuthenticated()) {
      return true;
    } else {
      this.router.navigate([APP_ROUTES.AUTH.NOT_APPROVED]);
      return false;
    }
  }
}
